import { Directive, inject, input, OnChanges, TemplateRef, ViewContainerRef } from '@angular/core';

import { SkeletonBlockComponent, SkeletonShape } from './skeleton-block.component';

/**
 * @example
 *   ```html
 *   <app-icon *appSkeleton="loading(); shape: 'rectangle'; width: '24px'; height: '24px'" ... />
 *   <div *appSkeleton="loading(); width: '70%'" class="message">{{ text }}</div>
 *   ```
 */
@Directive({ selector: '[appSkeleton]' })
export class SkeletonDirective implements OnChanges {
    private readonly templateRef = inject(TemplateRef<unknown>);
    private readonly viewContainer = inject(ViewContainerRef);

    readonly loading = input.required<boolean>({ alias: 'appSkeleton' });
    readonly shape = input<SkeletonShape>('text', { alias: 'appSkeletonShape' });
    readonly width = input<string | undefined>(undefined, { alias: 'appSkeletonWidth' });
    readonly height = input<string | undefined>(undefined, { alias: 'appSkeletonHeight' });

    ngOnChanges(): void {
        this.viewContainer.clear();

        if (this.loading()) {
            const skeleton = this.viewContainer.createComponent(SkeletonBlockComponent);
            skeleton.setInput('shape', this.shape());
            skeleton.setInput('width', this.width());
            skeleton.setInput('height', this.height());
        } else {
            this.viewContainer.createEmbeddedView(this.templateRef);
        }
    }
}
